import { useIntl } from '@weenat/wintl';
import isNil from 'lodash-es/isNil';
import { useRef, useState } from 'react';
import { useClient } from '../../../ClientProvider';
import queryClient from '../../../queryClient';
import schemas from '../../../schemas';
import useMutation from '../../../useMutation';
import useQuery from '../../../useQuery';
import useOrderedFields from '../../useOrderedFields';
import { decitraitResourceToOptions } from './utils';
const schema = schemas.decitrait.linkPlot;
/** @deprecated */
export const useDecitraitLinkPlot = ({ org, plot }) => {
    const client = useClient();
    const { t } = useIntl();
    const formRef = useRef();
    const resourcesRequest = useQuery(client.decitrait.getResources({ organizationId: plot.organizationId }));
    const resources = resourcesRequest.data;
    const decitraitPlotsRequest = useQuery(client.decitrait.plots({ organizationId: org.id }));
    const decitraitPlots = decitraitPlotsRequest.data;
    const decitraitPlotMatchingPlotName = decitraitPlots?.find((x) => x.name === plot.name);
    const initialValues = {
        decitraitPlotId: decitraitPlotMatchingPlotName?.id
    };
    const [decitraitPlotId, setDecitraitPlotId] = useState(initialValues.decitraitPlotId);
    const [linkPlot, linkPlotRequest] = useMutation(client.decitrait.linkPlot({ decitraitPlotId: decitraitPlotId }), {
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [client.decitrait.summary({ plotId: plot.id }).key]
            });
            queryClient.invalidateQueries({
                queryKey: [client.decitrait.plotDetail({ plotId: plot.id }).key]
            });
        }
    });
    const { isPending, isError, isSuccess } = linkPlotRequest;
    const orderedFieldProps = useOrderedFields(['decitraitPlotId'], formRef, {
        shared: { isDisabled: isPending }
    });
    if (!resources)
        return null;
    const props = {
        form: {
            schema,
            onSubmit: () => linkPlot({ plotId: plot.id, orgId: org.id }),
            initialValues,
            formRef
        },
        useOnChange: {
            onChange: (values) => setDecitraitPlotId(values.decitraitPlotId)
        },
        submitButton: {
            isDisabled: isPending || isNil(decitraitPlotId),
            isSuccess,
            isError,
            children: t('actions.confirm')
        },
        field: {
            ...orderedFieldProps,
            decitraitPlotId: {
                isAutocomplete: true,
                ...orderedFieldProps.decitraitPlotId,
                label: t('dss.decitrait.actions.link_decitrait_plot'),
                options: decitraitResourceToOptions(decitraitPlots)
            }
        }
    };
    return { props };
};
